<template>
  <v-navigation-drawer v-if="lDrawer" :mini-variant="false" v-model="drawer" floating :permanent="$vuetify.breakpoint.mdAndUp" app dense class="white pl-3 pr-1" width="250px">
    <!-- :src="current_user ? current_user.file_foto_tenant : $consts.LOGO" -->
    <v-container class="pa-0">
      <div class="pa-2">
        <v-img
          class="mr-auto ml-auto"
          src="https://cdn.siap.id/s3/simpkb/asset%20img/guru%20belajar%20dan%20berbagi/logo-kemendikbudristek-tanpa-ayogurubelajar.png"
          lazy-src="https://cdn.siap.id/s3/simpkb/asset%20img/guru%20belajar%20dan%20berbagi/logo-kemendikbudristek-tanpa-ayogurubelajar.png"
          contain
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
      <!-- <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="caption grey--text">Seri</v-list-item-title>
          <v-list-item-title class="font-weight-medium caption black--text mt-1" style="white-space:normal">{{ current_instansi ? current_instansi.nama : "" }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-1 my-1"></v-divider> -->

      <v-row column class>
        <v-col cols="12" class="pa-0 ma-0">
          <v-list dense class="fix-icon">
            <div v-for="item in items" :key="item.id ? item.id : item.title" class>
              <template v-if="item.subheader">
                <v-subheader v-if="!item.hidden" class="font-weight-bold black--text mx-5">{{ item.title }}</v-subheader>
              </template>
              <template v-else-if="item.items">
                <v-list-group v-if="!item.hidden" v-model="item.active" :prepend-icon="item.icon" no-action>
                  <template v-slot:activator>
                    <v-list-item-content v-if="item.items" :key="item.id ? item.id : item.title" exact>
                      <v-list-item-title class="primary--text" style="white-space: normal;">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-for="subItem in item.items">
                    <v-list-item v-if="!subItem.hidden" :key="subItem.id ? subItem.id : subItem.title" :to="subItem.to" :href="subItem.href" exact>
                      <v-list-item-title v-if="subItem.demo" style="white-space: normal;">
                        <v-badge color="error" content="demo">{{ subItem.title }}</v-badge>
                      </v-list-item-title>
                      <v-list-item-title v-else style="white-space: normal;">{{ subItem.title }}</v-list-item-title>
                      <v-list-item-action v-if="subItem.icon">
                        <v-icon>{{ subItem.icon }}</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list-group>
              </template>
              <template v-else>
                <v-list-item
                  class="my-2 mx-3 rounded-xl "
                  v-if="!item.hidden"
                  :key="item.id ? item.id : item.title"
                  :to="item.to"
                  :href="item.href"
                  active-class="my-active-link"
                  exact
                >
                  <v-list-item-action class="my-act-icon ml-5 mr-3 ma-0">
                    <v-icon :color="item.to.name == $route.name ? 'white' : '#838383'">{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content class="mr-5">
                    <v-list-item-title v-if="item.demo" style="white-space: normal;">
                      <v-badge color="error" content="demo">{{ item.title }}</v-badge>
                    </v-list-item-title>
                    <v-list-item-title style="white-space: normal;" :class="item.to.name == $route.name ? 'white--text' : '#838383'" v-else>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </div>
          </v-list>
          <!-- </v-row> -->
        </v-col>
      </v-row>
    </v-container>
    <PilihInstansi ref="dlg" />
  </v-navigation-drawer>
</template>

<script>
import MListGroup from "./MListGroup";
import MListTile from "./MListTile";
import PilihInstansi from "../modules/instansi/components/PilihInstansiDialog";

// @group Global Component
export default {
  components: {
    MListGroup,
    MListTile,
    PilihInstansi
  },
  data() {
    return {
      drawer: this.lDrawer
    };
  },
  computed: {
    lDrawer() {
      return this.$store.getters["main/lDrawer"];
    },
    items() {
      return this.$store.getters["menu/menus"];
    }
  },
  methods: {
    pilihInstansi() {
      this.$refs.dlg
        .open()
        .then(res => res)
        .catch(e => e);
      this.drawer = false;
    }
  },
  watch: {
    lDrawer(n) {
      this.drawer = n;
    },
    drawer(n) {
      this.$store.commit("main/setLDrawer", n);
    }
  }
};
</script>

<style>
.fix-icon .v-icon.fas {
  font-size: 1rem !important;
}
.fix-icon .my-act-icon .v-icon,
.fix-icon .v-list__group__header__prepend-icon .v-icon {
  font-size: 20px !important;
}
.fix-icon .my-act-icon,
.fix-icon .v-list__group__header .v-list__group__header__prepend-icon {
  padding-right: 0;
  min-width: 25px;
}
.fix-icon .v-list__group__items .v-list__tile {
  padding-left: 56px !important;
}
.fix-icon .my-active-link {
  color: #fff !important;
  background-color: #7400D9 ;
}
.fix-icon .link {
  color: #fff !important;
}
</style>
